export default "__VITE_ASSET__Bn4dt_aV__"